/*
 * @Author: your name
 * @Date: 2021-10-11 11:44:01
 * @LastEditTime: 2021-10-11 14:26:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc\src\service\api\staffType.js
 */
//员工类型
import http from '../httpConfig'

const table = "mrbase_sys_staff_type"

// 员工类型列表
export const staff_type_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-type/list-staff-type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增员工类型
export const staff_type_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-type/add-staff-type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改员工类型
export const staff_type_edit = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-type/update-staff-type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询员工类型详情
export const staff_type_detail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-type/find-staff-type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除员工类型
export const staff_type_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-type/delete-staff-type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

